import React from 'react';

const Header = () => {
    return (
        <>
            <div style={{border: "1px solid grey", height: "5vh"}} className="h-full">
                <h1 style={{fontSize: "32px"}}>Privmail</h1>
            </div>
        </>
    );
};

export default Header;
